import React from 'react'
import styles from './inputWTN.module.scss'
import formStyles from './styles/forms.module.scss'
import { FieldValidator, useField } from 'formik'
import cx from 'classnames'

interface Props
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string
  disableErrorMessage?: boolean
  validate?: FieldValidator
}

const InputWTN = ({
  label = '',
  className = '',
  disableErrorMessage = false,
  validate,
  ...props
}: Props) => {
  const [field, meta] = useField({ ...(props as any), validate })
  return (
    <>
      {label && (
        <label className={formStyles.formLabel} data-formik-error={field.name}>
          {label}
        </label>
      )}
      <input
        data-formik-error={field.name}
        className={cx(styles.input, className, { [formStyles.inputError]: meta.error })}
        {...field}
        {...props}
      />
      {!disableErrorMessage && meta.error && (
        <div className={formStyles.errorMessage}>{meta.error}</div>
      )}
    </>
  )
}

export default InputWTN
